module.exports = __webpack_public_path__ + "img/23.3ace18eb.jpg";